export default {
  contentUrl: {
    // getPageList: "/transport/logistics/getList", //查询列表
    saveContent: "/content/content/saveContent", //新建内容（包含 图文内容/测评内容
    queryContents: "/content/content/queryContents", //获取评测内容（图文）列表
    contentDetail: "/content/content/contentDetail", // 查看详情页
    editContent: "/content/content/editContent", // 编辑发布接口
    removeContent: "/content/content/removeContent", // 删除内容
    withdrawnContent: "/content/content/withdrawnContent", // 撤回内容
    contentOperationLogs: "/content/content/operationLogs", // 查看日志
    getSpecials: "/content/special/getSpecials", // 专栏列表
    getSpecialList: "/content/special/getSpecialList", // 专栏下拉数据
    addSpecial: "/content/special/addSpecial", // 新增专栏
    editSpecial:"/content/special/editSpecial",  //编辑专栏
    removeSpecial:"/content/special/removeSpecial", //删除专栏
    operationLogs:"/content/special/operationLogs",  //获取专栏日志
    getRootTags: "/content/tag/getRootTags", // 标签列表
    addRootTag: "/content/tag/addRootTag", // 新增主标签
    removeRootTag: "/content/tag/removeRootTag", //删除标签
    editRootTag: "/content/tag/editRootTag", // 编辑主标签
    tagOperationLogs:"/content/tag/operationLogs",  //获取标签操作日志
    getChildrenTags: "/content/tag/getChildrenTags", // 子标签列表
    addChildrenTag: "/content/tag/addChildrenTag", // 新增子标签
    getTagTree: "/content/tag/getTagTree", //标签树接口
    queryComments:"/content/comment/queryComments",//获取主评论列表
    removeMainComment:"/content/comment/removeMainComment/",//删除主评论
    getChildComments:"/content/comment/getChildComments/",//获取子评论
    setCommentTop:"/content/comment/setCommentTop/",//置顶评论
    cancelCommentTop:"/content/comment/cancelCommentTop/",//取消置顶评论
    commentOperationLogs:"/content/comment/operationLogs/",//查看主评论操作日志
    getTopicTree: '/content/topic/getTopicTree', //一级栏目
    getTopicNextNode: '/content/topic/getTopicNextNode/', //下级栏目数据
    getComments: '/content/comment/queryComments',
    getContentTestInfo: '/content/content/getContentTestInfo', // 获取测试配置列表
    copyConent: '/content/content/copyConent/', // 内容复制接口
  }
};